import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AssignmentFilterTopbar from './assignment_filter_topbar';
import AssignmentsTable from './assignments_table';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus, faProjectDiagram } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/ui/loading_spinner';
import SearchPage from 'components/search_page';
import PageHeader from 'components/ui/page_header';
import CsvDownloadButton from  'components/csv_download_button';

import { changePage } from './store/actions/query';
import { retrieveRecords, filterOptionsAsQueryParameter } from './store/actions/search';
import queryString from 'query-string';
import EmptyState from 'shared/empty_state';
import { Container } from 'react-bootstrap-5';

export class Assignments extends React.Component {
  static propTypes = {
    assignments: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
    isFetchingAssignments: PropTypes.bool.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    paths: PropTypes.shape({
      assignmentsCsvPath: PropTypes.string,
      emptyAssignmentImage: PropTypes.string.isRequired,
      newAssignment: PropTypes.string
    }).isRequired,
    query: PropTypes.shape({
      statusFilter: PropTypes.array.isRequired
    }).isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.retrieveRecords();
  }

  scrollPanel = React.createRef();

  handlePageChange = (page) => {
    this.props.onPageChange(page);
    this.props.retrieveRecords();
    this.scrollToTop();
  };

  render() {
    return (
      <React.Fragment>
        <SearchPage>
          <div className="overflow-auto">
            <PageHeader>
              <PageHeader.Heading
                description="Manage your existing Assignments or create new ones"
                icon={faProjectDiagram}
                title="Assignments"
              />
              <PageHeader.Actions>
                <CsvDownloadButton hasButtonToRight={false} href={this.csvDownloadPath()} type="Button" />
                {this.props.paths.newAssignment &&
                  <a className="btn btn-primary" href={this.props.paths.newAssignment}>
                    <span className="d-none d-sm-block">New Assignment</span>
                    <span className="d-sm-none">
                      <FontAwesomeIcon className="me-2" icon={faPlus} />
                      New
                    </span>
                  </a>}
              </PageHeader.Actions>
            </PageHeader>
            <AssignmentFilterTopbar />
            <div className="table-content">
              <div className="main-content" ref={this.scrollPanel}>
                {this.renderResults()}
                {this.renderPagination()}
              </div>
            </div>
          </div>
        </SearchPage>
      </React.Fragment>
    );
  }

  csvDownloadPath() {
    const filters = filterOptionsAsQueryParameter(this.props.query);
    const paramsQueryString = queryString.stringify(filters, { arrayFormat: 'bracket' });
    return `${this.props.paths.assignmentsCsvPath}?${paramsQueryString}`;
  }

  renderResults() {
    const { assignments, isFetchingAssignments, isFiltered, totalCount } = this.props;

    if (isFetchingAssignments) {
      return (
        <div className="py-4">
          <LoadingSpinner />
        </div>
      );
    } else if (assignments.length > 0) {
      return (
        <div className="border-bottom"><AssignmentsTable /></div>
      );
    } else if (totalCount === 0) {
      return (
        <Container className="py-4" fluid>
          {isFiltered ? this.renderNoResults() : this.renderNoAssignments()}
        </Container>
      );
    }
  }

  renderNoResults() {
    return (
      <EmptyState
        bodyText="Search with different criteria or create a New Assignment"
        header="No Results Found"
        icon={faSearch}
      />
    );
  }

  renderNoAssignments() {
    const { emptyAssignmentImage, newAssignment } = this.props.paths;

    return (
      <div className="no-results-panel text-center" name="noAssignments">
        <img src={emptyAssignmentImage} style={{ height: '50px' }} />
        <h5 className="mt-4 mb-2 fw-bold">
          You don't have any assignments yet!
        </h5>
        {newAssignment &&
          <p className="text-muted mb-4">
            Click&nbsp;
            <a href={newAssignment}>New Assignment</a>
            &nbsp;to get started
          </p>}
      </div>
    );
  }

  renderPagination() {
    if (!this.props.isFetchingAssignments) {
      if (this.props.assignments.length >= this.props.totalCount) return null;

      return (
        <div className="d-flex w-100 justify-content-center my-4">
          <UltimatePagination
            currentPage={this.props.currentPage}
            totalPages={this.props.totalPages}
            onChange={this.handlePageChange}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const isFiltered = !(
    state.query.searchText === '' &&
    state.query.assignmentTypeFilter.length === 0 &&
    state.query.brokerFilter == null &&
    state.query.propertyTypeFilter.length === 0 &&
    state.query.statusFilter.length === 0
  );

  return {
    ...state.search.meta,

    assignments: state.search.assignments,
    isFetchingAssignments: state.search.isFetching,
    isFiltered,
    paths: state.paths,
    query: state.query
  };
};

const mapDispatchToProps = {
  onPageChange: changePage,
  retrieveRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(Assignments);
